import React from 'react';
import { AlertCircle } from 'lucide-react';
import { USE_GOBODO_API } from '../../utils/gobodoUtils';

interface GobodoRequiredGuardProps {
  children: React.ReactNode;
}

export const GobodoRequiredGuard: React.FC<GobodoRequiredGuardProps> = ({ children }) => {
  if (USE_GOBODO_API) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-[400px] flex items-center justify-center p-8">
      <div className="max-w-md text-center">
        <AlertCircle className="h-16 w-16 text-amber-500 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Gobodo API Required
        </h2>
        <p className="text-gray-600 dark:text-gray-400">
          This application requires the Gobodo backend. Set <code className="bg-gray-100 dark:bg-gray-800 px-1 rounded">REACT_APP_USE_GOBODO_API=true</code> and configure <code className="bg-gray-100 dark:bg-gray-800 px-1 rounded">REACT_APP_GOBODO_API_URL</code> to use this feature.
        </p>
      </div>
    </div>
  );
};
